import request from '@/http/module/request'

export function login (username, password) {
  const url = '/auth/signin'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  const params = {
    username: username,
    password: password
  }

  return request.post(url, params, config)
}

export function snsLogin (snsId) {
  const url = '/auth/signin/sns'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  const params = {
    snsId: snsId
  }

  return request.post(url, params, config)
}

export function getUserInfo (token) {
  const url = '/user/select'

  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  }

  const params = {}

  return request.post(url, params, config)
}

export function signup (params) {
  const url = '/auth/signup'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return request.post(url, params, config)
}

export function checkDuplicatedId (username) {
  const url = '/auth/checkId'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  const params = {
    username: username
  }

  return request.post(url, params, config)
}

export function sendAuthNo (params) {
  const url = '/auth/sendAuthNo'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return request.post(url, params, config)
}

export function requestFindId (params) {
  const url = '/auth/findId'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return request.post(url, params, config)
}

export function requestFindPassword (params) {
  const url = '/auth/findPwd'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return request.post(url, params, config)
}

export function requestUpdatePassword (params) {
  const url = '/auth/updatePwd'

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }

  return request.post(url, params, config)
}



// WEBPACK FOOTER //
// ./src/http/api/account.js